export default {
  //Used for Invite Users dialog
  snap_compact: {
    overlay:
      "fixed top-0 left-0 w-full h-full flex items-center justify-center bg-black bg-opacity-70 z-50 p-4",
    container:
      "w-full max-w-sm max-h-[90vh] bg-paper rounded-2xl border border-bordered shadow-lg overflow-hidden",
    header: "relative flex justify-between items-center p-2",
    closeButton: "absolute right-3 top-3 hover:text-white z-20",
    closeIcon: "h-6 w-6 text-text_secondary hover:text-text",
    title: "flex-1 text-lg font-bold text-text",
    headerContent: "flex items-center",
    contentWrapper: "overflow-y-auto scrollbar-thin scrollbar-thumb-neutral_2 scrollbar-track-paper",
    content: "",
  },
  
  //Used for ContactSales, Pricing  - Seat options modal, etc.
  snap_medium: {
    overlay:
      "fixed top-0 left-0 w-full h-full flex items-center justify-center bg-slate-600 bg-opacity-30",
    container:
      "w-full md:w-[755px] h-full md:h-auto md:max-h-[calc(100vh-2rem)] bg-paper md:rounded-[24px] py-8",
    header: "relative flex justify-between items-center px-10 mb-0",
    closeButton: "absolute right-6 md:right-8 top-0 md:top-1 z-10",
    closeIcon: "h-7 w-7 text-neutral_2 hover:text-neutral_3",
    title:
      "flex-1 text-[24px] md:text-[28px] font-bold text-text text-center md:text-left leading-tight mt-8 mb-0 md:my-0",
    headerContent: "flex items-center",
    contentWrapper:
      "w-full max-h-[calc(100vh-10rem)] overflow-y-auto scrollbar-thin scrollbar-thumb-neutral_2 scrollbar-track-paper px-4",
    content: "w-full md:px-6 md:py-0",
  },
}
